export default "__VITE_ASSET__0b249d74__"